import { useInfiniteQuery } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const getOpenConcerns = async ({ pageParam = 1, token }) => {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/raise/concerns/open?page=${pageParam}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch all open concerns");
  }

  return response.json();
};

const useFetchOpenConcerns = () => {
  const { token } = useContext(AuthContext);

  return useInfiniteQuery(
    ["openConcerns"],
    ({ pageParam = 1 }) => getOpenConcerns({ pageParam, token }),
    {
      getNextPageParam: (lastPage) => {
        const { currentPage, totalConcerns } = lastPage;
        const totalPages = Math.ceil(totalConcerns / 10);
        return currentPage < totalPages ? currentPage + 1 : undefined;
      },
      keepPreviousData: true,
    }
  );
};

export default useFetchOpenConcerns;
